import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserService } from './user.service';
import { ToastService } from './toast.service';
import { ModalInfo, WorkspacesInfo } from '../models';

export interface ObservableInfo {
  name: string;
  state: boolean;
  update: ModalInfo | WorkspacesInfo;
}
@Injectable({
  providedIn: 'root'
})
export class ObservableService {

  private subject$: ObservableInfo = {name : '', state: false, update : null};
  private updateService = new BehaviorSubject(this.subject$);
  /* Observable that activates when an execution status passed from Running to Completed */
  private canUpdateExecutionStatus: string = '';
  private updateExecutionStatus = new BehaviorSubject(this.canUpdateExecutionStatus);

  private canUpdateNotificationsModal: string = '';
  private updateNotificationsModal = new BehaviorSubject(this.canUpdateNotificationsModal);

  private isNotificated: boolean = false;
  private updateNotificationService = new BehaviorSubject(this.isNotificated);
  // method to call for subscribe //
  update = this.updateService.asObservable();
  notification = this.updateNotificationService.asObservable();
  executionStatus = this.updateExecutionStatus.asObservable();
  updateNotificationsObs = this.updateNotificationsModal.asObservable();


  constructor(
    private userService: UserService,
    private toastService: ToastService,
    ) { }

  updateData(data: ObservableInfo) {
    this.updateService.next(data);
  }

  updateStatusExecution(canUpdateExecutionStatus: string) {
    this.updateExecutionStatus.next(canUpdateExecutionStatus);
  }

  // method to have always the current value
  async updateNotificationData() {
    try {
      const user = await this.userService.getUserInfo();
      this.updateNotificationService.next(user.new_notification);
    } catch (error) {
      // Wrong error response
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  updateNotifications(canUpdateNotificationsModal: string) {
    this.updateNotificationsModal.next(canUpdateNotificationsModal);
  }
}
